module.exports = __webpack_public_path__ + "res/dummy_menu.817a8c983a38d2c9505f307b8effe477.png";